<div class="container-fluid pt-3 pb-3">
  <h6 class="fw-bold text-primary mb-3">{{ 'astronomicalClockAnalytics' | translate }}</h6>

  <app-filters-time
    [activeFilter]="activeFilter"
    [customStartDate]="customStartDate"
    [customEndDate]="customEndDate"
    [showPriceFilter]="false"
    (filterChange)="onFilterChange($event)"
    (customDateChange)="onCustomDateChange($event)"
    (monthSelected)="onCustomDateChange($event)">
  </app-filters-time>

  <div class="card mt-3 card-historics-spec">
    <div class="card-body py-3">
      <div class="row">
        <div class="col-xl-8">
          <div class="position-relative analytics-chart-wrapper">
            <div *ngIf="loading" class="position-absolute top-50 start-50 translate-middle">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{ 'loading' | translate }}</span>
              </div>
            </div>
            <div *ngIf="!loading && !hasData" class="position-absolute top-50 start-50 translate-middle text-muted">
              {{ 'noDataAvailable' | translate }}
            </div>
            <canvas id="chart-analytics"></canvas>
          </div>
        </div>
        <div class="col-xl-4">
          <h6 class="text-light">{{ 'energyConsumed' | translate }}</h6>
          <h3 class="text-end">{{ totalEnergy / 1000 | number:'1.2-2' }} kWh</h3>
        </div>
      </div>
    </div>
  </div>
</div>
